// Matching modules are required into this module.
function requireAll(requireContext) {
	return requireContext.keys().map(requireContext);
}

/*requireAll(require.context('../component assets/dtna/', true, /\.js$/));*/
requireAll(require.context('../component assets/dtna/alert-dialog/', true, /\.js$/));
requireAll(require.context('../component assets/dtna/category-diagram/', true, /\.js$/));
requireAll(require.context('../component assets/dtna/category-filter/', true, /\.js$/));
requireAll(require.context('../component assets/dtna/download-button/', true, /\.js$/));
/*requireAll(require.context('../component assets/dtna/drop-down-menu/', true, /\.js$/));*/
/*requireAll(require.context('../component assets/dtna/embed-media/', true, /\.js$/));*/
requireAll(require.context('../component assets/dtna/hot-sheet-library/', false, /\.js$/));
requireAll(require.context('../component assets/dtna/notification/', true, /\.js$/));
requireAll(require.context('../component assets/dtna/part-category/', true, /\.js$/));
requireAll(require.context('../component assets/dtna/parts-guide/', false, /\.js$/));
requireAll(require.context('../component assets/dtna/parts-table/', false, /\.js$/));
requireAll(require.context('../component assets/dtna/parts-view-toggle/', false, /\.js$/));
requireAll(require.context('../component assets/dtna/promotion/', false, /\.js$/));
requireAll(require.context('../component assets/dtna/promotions/', false, /\.js$/));
requireAll(require.context('../component assets/dtna/table-to-csv/', false, /\.js$/));
requireAll(require.context('../component assets/dtna/video-library/', false, /\.js$/));




require('normalize.css');
requireAll(require.context('../component assets/dtna/', true, /\.css$/));

require('@fortawesome/fontawesome-free/css/all.css');
require('../component assets/globals/scss/styles.scss');
requireAll(require.context('../component assets/dtna/notification/', true, /\.scss$/));
requireAll(require.context('../component assets/dtna/alert-dialog/', true, /\.scss$/));
requireAll(require.context('../component assets/dtna/hot-sheet-library/', false, /\.scss$/));
requireAll(require.context('../component assets/dtna/video-library/', false, /\.scss$/));
requireAll(require.context('../component assets/dtna/related-videos/', false, /\.scss$/));



// ====================//
// Imports and Exports //
// ====================//

// Base Elements & Components
// -------------
// - JavaScript classes for use with components and base-elements.
// - The following statements import classes from actual locations to
//   be consumed from this file instead of their actual locations.
export * from '../component assets/globals/js/components';

export { default as settings } from '../component assets/globals/js/settings';